export default "__VITE_ASSET__4da4c5fc__"